/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import { observer } from 'mobx-react';
import * as React from 'react';
import { IWineClubInputProps } from './wine-club.types';

//==============================================================================
/**
 * WineClubInputRadioCheckbox component
 * @extends {React.Component<IWineClubInputProps>}
 */
//==============================================================================
@observer
class WineClubInputRadioCheckbox extends React.Component<IWineClubInputProps> {

    //==========================================================================
    // Public Methods
    //==========================================================================

    public render(): JSX.Element {
        return (
            <div className='form-check'>
                <label className='form-check-label'>
                    <input
                        className='form-check-input'
                        type={this.props.type}
                        id={this.props.id}
                        data-group={this.props.group && this.props.group}
                        value={this.props.value}
                        checked={this.props.checked}
                        onChange={this.props.handleChange}
                    />
                    {this.props.value}
                </label>
            </div>

        );
    }
}

export default WineClubInputRadioCheckbox;